import { Injectable } from '@angular/core';
import { Http, Headers, ResponseContentType } from '@angular/http';
import { Router } from '@angular/router';
import { Token } from '../manager/token';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
// import 'rxjs/Rx';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ClientApprovalService {
  TokenCls

  constructor(private http: HttpClient, private router: Router) {
    this.TokenCls = new Token(this.router);
  }

  getPracticeNameList(ClientId):any {
    // get-practice

    return this.http.get(environment.ApiUrl + `/api/get-practice/${ClientId}`).pipe(map(res => res));
  }

  GetSummaryAndComments(ClientId: number, fromdate, todate, status, practice):any {
    if (practice == null || practice.length == 0) {
      practice = 'ALL';;
    }
    return this.http.get(environment.ApiUrl + '/api/client-approval/client/' + ClientId + '?FromDate=' + fromdate + '&ToDate=' + todate + '&Status=' + status + '&practice=' + practice);
  }

  GetAging(clientId, action, FromDate, ToDate, SelectedComment: string, practice):any {
    if (practice == null || practice.length == 0) {
      practice = 'ALL';;
    }
    return this.http.get(environment.ApiUrl + '/api/client-approval/client/' + clientId + '?status=' + action + '&FromDate=' + FromDate + '&ToDate=' + ToDate + '&comment=' + SelectedComment + '&practice=' + practice);
  }

  GetInventories(ClientId: number, Action: string, FromDate: string, ToDate: string, SelectedComment: string, Ageing_Bucket_Name: any, practice):any {
    if (practice == null || practice.length == 0) {
      practice = 'ALL';;
    }
    return this.http.get(environment.ApiUrl + '/api/client-approval/client/' + ClientId + '?status=' + Action + '&FromDate=' + FromDate + '&ToDate=' + ToDate + '&comment=' + SelectedComment + '&filter=' + Ageing_Bucket_Name + '&practice=' + practice);
  }

  SaveInventories(response):any {
    return this.http.post(environment.ApiUrl + '/api/client-approval', response);
  }

  GetReferenceFile(filename: any):any {
    return this.http.post(environment.FileApiUrl + '/api/approval-file-download', { Reference_File_Name: filename }, { responseType: 'blob'})
      .pipe(map(res => {
        return {
          filename: filename,
          data: res
        };
      }));

  }

  ViewCommentHistory(Client_Id: any, Inventory_Id: any):any {
    return this.http.get(environment.ApiUrl + '/api/client-approval/client/' + Client_Id + '/' + Inventory_Id);
  }

  excelData(ClientId: number, fromdate, todate, status, practice):any {
    if (practice == null || practice.length == 0) {
      practice = 'ALL';
    }
    return this.http.get(environment.ApiUrl + `/api/Get_Client_Assistance_Summary_Report?Id=${ClientId}&status=${status}&FromDate=${fromdate}&ToDate=${todate}&practice=${practice}`).pipe(map(res => res));
  }

}
